import { useTenantStore } from '../../stores/tenant.store';
import { Loader } from '../ui';

/**
 * Splash screen shown during initial app loading
 */
export function SplashScreen() {
  const tenant = useTenantStore((state) => state.tenant);

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #f0f4ff 0%, #e0e9ff 100%)',
        zIndex: 9999,
        gap: '24px',
      }}
    >
      {tenant?.logo && (
        <img
          src={tenant.logo}
          alt={tenant.displayName || tenant.name}
          style={{ height: '64px', width: 'auto' }}
        />
      )}

      <Loader
        variant="inline"
        size="large"
        message={`Loading ${tenant?.displayName || 'Platform'}...`}
      />
    </div>
  );
}
